import React, { useState } from 'react';
import {
    useUploadFileMutation,
    useDeleteFileMutation,
    useReplaceFileMutation,
    useGetFileQuery
} from '../../../features/fileupload/fileuploadApiSlice';

const FileUpload = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadedFilePath, setUploadedFilePath] = useState(null);
    const [filename, setFilename] = useState('');

    const [uploadFile] = useUploadFileMutation();
    const [deleteFile] = useDeleteFileMutation();
    const [replaceFile] = useReplaceFileMutation();
    const { data: fileData, error: fileError, refetch } = useGetFileQuery(filename, {
        skip: !filename
    });

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleFileUpload = async () => {
      if (!selectedFile) {
          alert('Please select a file first');
          return;
      }
  
      const folderName = "TestFolder"
      const jsonData = {collection:"new", data:{ key1: "value1", key2: "value2" }}; // Replace with your actual JSON data
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('jsonData', JSON.stringify(jsonData));
      console.log(formData)

      // prompt('Enter folder name:'); // Get folder name from user input
  
      try {
          const response = await uploadFile({ formData, folder: folderName }).unwrap();
          setUploadedFilePath(response.filePath);
          alert('File uploaded successfully');
      } catch (error) {
          console.error('Error uploading file:', error);
          alert('Failed to upload file');
      }
  };

  const handleFileDelete = async () => {
    const folderName = "TestFolder"; // Or get this from user input
    const filename = "example.txt"; // Or get this from user input or state

    try {
        await deleteFile({ folder: folderName, filename }).unwrap();
        alert('File deleted successfully');
    } catch (error) {
        console.error('Error deleting file:', error);
        alert('Failed to delete file');
    }
};

    const handleFileReplace = async () => {
        if (!selectedFile) {
            alert('Please select a file first');
            return;
        }
    
        const folderName = "TestFolder"; // Or get this from user input
        const filename = "example.txt"; // Or get this from user input or state
    
        try {
            const response = await replaceFile({ folder: folderName, filename, file: selectedFile }).unwrap();
            setUploadedFilePath(response.filePath);
            alert('File replaced successfully');
        } catch (error) {
            console.error('Error replacing file:', error);
            alert('Failed to replace file');
        }
    };

    const handleGetFile = () => {
        if (!filename) {
            alert('Please enter a filename');
            return;
        }
        refetch();
    };

    return (
        <div>
            <h1>File Upload</h1>
            <input type="file" onChange={handleFileChange} />
            <button onClick={handleFileUpload}>Upload</button>
            <button onClick={handleFileDelete} disabled={!uploadedFilePath}>Delete</button>
            <button onClick={handleFileReplace} disabled={!uploadedFilePath}>Replace</button>
            {uploadedFilePath && <p>Uploaded file path: {uploadedFilePath}</p>}

            <h2>Get File Info</h2>
            <input
                type="text"
                placeholder="Enter filename"
                value={filename}
                onChange={(e) => setFilename(e.target.value)}
            />
            <button onClick={handleGetFile}>Get File Info</button>
            {fileData && (
                <div>
                    <p>Filename: {fileData.filename}</p>
                    <p>URL: <a href={fileData.url} target="_blank" rel="noopener noreferrer">{fileData.url}</a></p>
                </div>
            )}
            {fileError && <p>Error fetching file info: {fileError.message}</p>}
        </div>
    );
};

export default FileUpload;
